@for (step of steps; track step; let i = $index; let isLast = $last) {
  <div
    class="step"
    [class.hidden]="selectedIndex !== i"
    [attr.tabindex]="selectedIndex === i ? 0 : null"
    [attr.aria-expanded]="selectedIndex === i"
  >
    <ng-container [ngTemplateOutlet]="step.content"></ng-container>
  </div>
}
